<template>
  <NuxtLayout name="default">
    <NuxtPage />
  </NuxtLayout>
</template>

<style lang="scss">
@use './assets/scss/styles.scss';

/* Page & Layout Transitions */
.page-enter-active,
.page-leave-active,
.layout-enter-active,
.layout-leave-active {
  transition: opacity 0.2s cubic-bezier(0.55, 0, 0.1, 1);
}

.page-enter-from,
.page-leave-to,
.layout-enter-from,
.layout-leave-to {
  opacity: 0;
}

/* Slide Transitions */
.slide-enter-active,
.slide-leave-active {
  transition:
    opacity 0.2s ease-in-out,
    transform 0.2s ease-in-out;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translate3d(-1rem, 0, 0);
}

/* Fade Transitions */
.fade-leave-active {
  transition:
    opacity 0.5s ease,
    height 1.5s ease;
}

.fade-enter-active {
  transition:
    opacity 1s ease,
    height 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  height: 0px;
}
</style>
